import { createRoot } from "react-dom/client";
import App from "./app";
import "./styles/ktv.css";
import "./styles/ktv-extras.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root in index.html");
createRoot(rootEl).render(<App />);
